module.exports = new __parcel__URL__("arrow-down-red.dc4ab5aa.png").toString();